var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext } from "react";
import { Box, Divider } from "@mui/material";
import { CohortInsightsPageFilters, Filters } from "../Filters/Filters";
import ImpactComponent from "./ImpactComponent";
import HeidrickScoreChart from "../HeidrickScoreChart/HeidrickScoreChart";
import StatusInfo from "../StatusInfo/StatusInfo";
import { getClientId, useGetLeaderCohortInsightsStrengthsWeaknessesQuery, useGetScoreStateQuery, useGetLeaderCohortInsightsLowestOpportunitiesQuery, useGetLookupsFiltersQuery, } from "../../store/api/core";
import styles from "./LeaderInsights.module.scss";
import { FilterContext } from "../../providers/FilterProvider";
import LeaderCount from "../../components/LeaderCount/";
import { getRoute } from "../../routes/getAllRoutes";
import { useNavigate } from "react-router-dom";
import { LocalFactorScoresSelection, LocalPaneSelector, } from "./ScoreBySkillPage";
var transformData = function (input) {
    var categories = [
        "Capabilities",
        "Potential",
        "Functional Impact",
        "Organizational Impact",
    ];
    var colors = ["var(--bad-1)", "var(--neutral-1)", "var(--good-1)"];
    var link = "https://www.google.com";
    var dataArr = categories.map(function (category) { return ({
        title: category === "Capabilities"
            ? "Leadership Capabilities"
            : category === "Potential"
                ? "Agility & Potential"
                : category === "Functional Impact"
                    ? "Functional Impact"
                    : "Organizational Impact",
        strengths: ((input === null || input === void 0 ? void 0 : input.strengths[category]) || [])
            .filter(function (item) { return item.averagePercentage >= 90; })
            .map(function (item) { return (__assign(__assign({}, item), { colors: colors, link: link })); }),
        weaknesses: ((input === null || input === void 0 ? void 0 : input.weaknesses[category]) || [])
            .filter(function (item) { return item.averagePercentage < 90; })
            .map(function (item) { return (__assign(__assign({}, item), { colors: colors, link: link })); }),
    }); });
    return dataArr;
};
var LocalLeaderCount = function (_a) {
    var _b, _c;
    var useOverview = _a.useOverview, countText = _a.countText;
    var getFilters = useContext(FilterContext).getFilters;
    var scores = useOverview({ filters: __assign({}, getFilters()) });
    var totalNumberCount = (_c = (_b = scores === null || scores === void 0 ? void 0 : scores.data) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.leaders_count;
    return _jsx(LeaderCount, { leadersCount: totalNumberCount, countText: countText });
};
export var DataRelations = {
    "Leadership Capabilities": {
        key: "capability",
        scoreType: "Capabilities",
        factorChart: _jsx(LocalFactorScoresSelection, { skillGroup: "capability" }),
    },
    "Agility & Potential": {
        key: "potential",
        scoreType: "Potential",
        factorChart: _jsx(LocalFactorScoresSelection, { skillGroup: "potential" }),
    },
    "Organizational Impact": {
        key: "organizational",
        scoreType: "Organizational Impact",
        factorChart: _jsx(LocalFactorScoresSelection, { skillGroup: "organizational" }),
    },
    "Functional Impact": {
        key: "functional",
        scoreType: "Functional Impact",
        factorChart: _jsx(LocalPaneSelector, { skillGroup: "functional" }),
    },
};
var LeaderInsights = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5;
    var navigate = useNavigate();
    var getFilters = useContext(FilterContext).getFilters;
    var functionAndLevelData = useGetLookupsFiltersQuery({
        clientId: getClientId(),
    });
    var getFunctionLabel = function (functionValue) {
        var _a, _b, _c, _d;
        return (((_d = (_c = (_b = (_a = functionAndLevelData === null || functionAndLevelData === void 0 ? void 0 : functionAndLevelData.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.function) === null || _c === void 0 ? void 0 : _c.find(function (item) { return item.value === functionValue; })) === null || _d === void 0 ? void 0 : _d.label) || "--");
    };
    var getLevelLabel = function (levelValue) {
        var _a, _b, _c, _d;
        return (((_d = (_c = (_b = (_a = functionAndLevelData === null || functionAndLevelData === void 0 ? void 0 : functionAndLevelData.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.level) === null || _c === void 0 ? void 0 : _c.find(function (item) { return item.value === levelValue; })) === null || _d === void 0 ? void 0 : _d.label) || "--");
    };
    var getLabels = function (arr) {
        return arr === null || arr === void 0 ? void 0 : arr.filter(function (item) { return item.value < 90; }).map(function (item) { return (__assign(__assign({}, item), { function_label: getFunctionLabel(item.function_id), level_label: getLevelLabel(item.level_id) })); });
    };
    var overview = useGetScoreStateQuery({ filters: getFilters() });
    var strengthWeaknesses = useGetLeaderCohortInsightsStrengthsWeaknessesQuery({ filters: getFilters() });
    var strengthWeaknessArr = transformData((_a = strengthWeaknesses === null || strengthWeaknesses === void 0 ? void 0 : strengthWeaknesses.data) === null || _a === void 0 ? void 0 : _a.data);
    var lowestOpportunities = useGetLeaderCohortInsightsLowestOpportunitiesQuery({});
    var enrichedData = {};
    if ((lowestOpportunities === null || lowestOpportunities === void 0 ? void 0 : lowestOpportunities.data) !== undefined) {
        enrichedData = {
            capability: getLabels((_c = (_b = lowestOpportunities === null || lowestOpportunities === void 0 ? void 0 : lowestOpportunities.data) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.capability),
            potential: getLabels((_e = (_d = lowestOpportunities === null || lowestOpportunities === void 0 ? void 0 : lowestOpportunities.data) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.potential),
            organizational: getLabels((_g = (_f = lowestOpportunities === null || lowestOpportunities === void 0 ? void 0 : lowestOpportunities.data) === null || _f === void 0 ? void 0 : _f.data) === null || _g === void 0 ? void 0 : _g.organizational),
            functional: getLabels((_j = (_h = lowestOpportunities === null || lowestOpportunities === void 0 ? void 0 : lowestOpportunities.data) === null || _h === void 0 ? void 0 : _h.data) === null || _j === void 0 ? void 0 : _j.functional),
        };
    }
    var navigateToSkillHelper = function (title, apiType) {
        var _a, _b;
        return navigate(getRoute("ScoreBySkillPage"), {
            state: {
                groupsByData: getLabels((_b = (_a = lowestOpportunities === null || lowestOpportunities === void 0 ? void 0 : lowestOpportunities.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b[apiType]),
                title: title,
                apiType: apiType,
            },
        });
    };
    var data = [
        {
            label: "Organizational Impact Score",
            score: Math.round((_o = (_m = (_l = (_k = overview === null || overview === void 0 ? void 0 : overview.data) === null || _k === void 0 ? void 0 : _k.data) === null || _l === void 0 ? void 0 : _l.organizational) === null || _m === void 0 ? void 0 : _m.score) !== null && _o !== void 0 ? _o : 0),
            tooltip: "Average Organizational Impact Score for leaders, assessing alignment with " +
                "Organizational Impact requirements for their current role.",
            onClick: function () {
                return navigateToSkillHelper("Organizational Impact", "organizational");
            },
        },
        {
            label: "Leadership Capabilities Score",
            score: Math.round((_s = (_r = (_q = (_p = overview === null || overview === void 0 ? void 0 : overview.data) === null || _p === void 0 ? void 0 : _p.data) === null || _q === void 0 ? void 0 : _q.capability) === null || _r === void 0 ? void 0 : _r.score) !== null && _s !== void 0 ? _s : 0),
            tooltip: "Average Leadership Capabilities Score for leaders, assessing alignment with " +
                "Leadership Capabilities requirements for their current role.",
            onClick: function () {
                return navigateToSkillHelper("Leadership Capabilities", "capability");
            },
        },
        {
            label: "Functional Impact Score",
            score: Math.round((_w = (_v = (_u = (_t = overview === null || overview === void 0 ? void 0 : overview.data) === null || _t === void 0 ? void 0 : _t.data) === null || _u === void 0 ? void 0 : _u.functional) === null || _v === void 0 ? void 0 : _v.score) !== null && _w !== void 0 ? _w : 0),
            tooltip: "Average Functional Impact Score for leaders, assessing alignment with " +
                "Functional Impact requirements for their current role.",
            onClick: function () { return navigateToSkillHelper("Functional Impact", "functional"); },
        },
        {
            label: "Agility & Potential Score",
            score: Math.round((_0 = (_z = (_y = (_x = overview === null || overview === void 0 ? void 0 : overview.data) === null || _x === void 0 ? void 0 : _x.data) === null || _y === void 0 ? void 0 : _y.potential) === null || _z === void 0 ? void 0 : _z.score) !== null && _0 !== void 0 ? _0 : 0),
            tooltip: "Average Agility & Potential Score for leaders, assessing alignment with " +
                "Agility & Potential requirements for their current role.",
            onClick: function () { return navigateToSkillHelper("Agility & Potential", "potential"); },
        },
    ];
    var score = {
        score: (((_3 = (_2 = (_1 = overview === null || overview === void 0 ? void 0 : overview.data) === null || _1 === void 0 ? void 0 : _1.data) === null || _2 === void 0 ? void 0 : _2.overall_score) === null || _3 === void 0 ? void 0 : _3.score) / 5) * 100,
        tooltip: "Average Heidrick Score for leaders, assessing alignment to current role requirements " +
            "in terms of functional impact, organizational impact, capability, and potential.",
        onClick: function () {
            var _a, _b;
            return navigate(getRoute("OverallHeidrickScorePage"), {
                state: {
                    groupsByData: getLabels((_b = (_a = lowestOpportunities === null || lowestOpportunities === void 0 ? void 0 : lowestOpportunities.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.overall_score),
                },
            });
        },
    };
    return (_jsxs(Box, { children: [_jsx(Box, { children: _jsxs(Box, __assign({ className: styles.StyledParagraph }, { children: ["Insights on how your leadership population aligns with success profile requirements for their", " ", _jsx(Box, __assign({ sx: {
                                textDecoration: "underline",
                            }, component: "span" }, { children: "current role" })), " ", "across \u2013 pivotal expertise & business impact, leadership capabilities, and agility & potential \u2013 using an average score."] })) }), _jsx(Box, __assign({ className: styles.StyledMainContainer }, { children: _jsx(Box, __assign({ className: styles.StyledAllLeaderText }, { children: " All Leaders" })) })), _jsx(Box, __assign({ className: styles.divider }, { children: _jsx(Box, __assign({ className: styles.filterDivStyle }, { children: _jsx(Filters, { availableFilters: CohortInsightsPageFilters, leftTrailer: _jsx(LocalLeaderCount, { useOverview: useGetScoreStateQuery, countText: "leader" }) }) })) })), _jsxs(Box, __assign({ className: styles.StyledMainBg }, { children: [_jsx(Box, __assign({ className: styles.statusCardContainer }, { children: _jsx(StatusInfo, { heading: "Status", data: [
                                {
                                    text: "Act",
                                    bgColor: "var(--bad-1)",
                                    brColor: "var(--bad-2)",
                                },
                                {
                                    text: "Watch",
                                    bgColor: "var(--neutral-1)",
                                    brColor: "var(--neutral-2)",
                                },
                                {
                                    text: "Maintain",
                                    bgColor: "var(--good-1)",
                                    brColor: "var(--good-2)",
                                },
                            ] }) })), _jsx(Box, __assign({ className: styles.StyledCard }, { children: _jsxs(Box, { children: [_jsxs(Box, __assign({ className: styles.ScorechartDiv }, { children: [_jsx(Box, __assign({ className: styles.StyledAvgText, style: {
                                                fontSize: "24px",
                                                fontWeight: 500,
                                                lineHeight: "32px",
                                                color: "var(--grey-color-90)",
                                            } }, { children: "Average Score (Current Role)" })), _jsxs(Box, __assign({ className: styles.StyletotalLeadersText }, { children: ["Total Leaders ", (_5 = (_4 = overview === null || overview === void 0 ? void 0 : overview.data) === null || _4 === void 0 ? void 0 : _4.data) === null || _5 === void 0 ? void 0 : _5.leaders_count] }))] })), _jsx(Box, __assign({ className: styles.divider }, { children: _jsx(Divider, {}) })), _jsx(Box, { children: _jsx(HeidrickScoreChart, { dataset: data, overallScore: score }) })] }) })), strengthWeaknessArr === null || strengthWeaknessArr === void 0 ? void 0 : strengthWeaknessArr.map(function (item) {
                        var _a, _b, _c, _d;
                        return (_jsx(_Fragment, { children: _jsx(Box, __assign({ className: styles.StyledCard }, { children: _jsx(ImpactComponent, { heading: item.title, avgScore: (((_c = (_b = (_a = overview === null || overview === void 0 ? void 0 : overview.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b[DataRelations[item.title].key]) === null || _c === void 0 ? void 0 : _c.score) || 0).toFixed(1), avgScoreClick: function () {
                                        return navigateToSkillHelper(item.title, DataRelations[item.title].key);
                                    }, strengthData: item.strengths, weaknessesData: item.weaknesses, lowestOpportunities: Object.values(((_d = lowestOpportunities === null || lowestOpportunities === void 0 ? void 0 : lowestOpportunities.data) === null || _d === void 0 ? void 0 : _d.data) || {}).some(Boolean) && (enrichedData === null || enrichedData === void 0 ? void 0 : enrichedData[DataRelations[item.title].key]) }) })) }));
                    })] }))] }));
};
export default LeaderInsights;
